document.addEventListener('DOMContentLoaded', function() {
  var cartIconDesktop = document.getElementById('cart-icon-desktop');
  var cartIconMobile = document.getElementById('cart-icon-mobile');
  var drawer = document.getElementById('cart-drawer');

  function openDrawer(opener) {
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(opener);
    } else if (drawer) {
      drawer.setAttribute('open','');
    }
  }

  if (cartIconDesktop) {
    cartIconDesktop.addEventListener('click', function(e){
      e.preventDefault();
      openDrawer(cartIconDesktop);
    });
  }

  if (cartIconMobile) {
    cartIconMobile.addEventListener('click', function(e){
      e.preventDefault();
      openDrawer(cartIconMobile);
    });
  }
});
// Esto hace que cambie el título de la variante cuando cambias el select
document.addEventListener('change', function(e) {
  // Solo aplica si el cambio ocurre en un radio del quick add de variante
  if (e.target && e.target.type === 'radio' && e.target.name === 'quickadd-size-option') {
    // Valor seleccionado del radio
    var selectedText = e.target.value;
    // Busca el contenedor del producto rápido
    var productDetails = e.target.closest('.js-product-details');
    if (!productDetails) return;
    // Busca el span del título de la variante
    var variantTitle = productDetails.querySelector('#variant-title');
    if (variantTitle) {
      variantTitle.textContent = '– ' + selectedText + ' ';
    } else {
      console.log('No encontró el span #variant-title');
    }
  }
});